import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SessionService } from '../services/session.service';

/**
 * Guard for routes that require an organization. Use together with authGuard (auth first).
 *
 * It awaits `session.load()` rather than fetching: the app initializer has already fired the
 * same request, and `load()` hands back that in-flight promise, so a hard reload costs one
 * request rather than two.
 *
 * On a transport failure it lets the navigation through. It used to route to `/onboarding` on
 * *any* failure, which told a user with a perfectly good organization that they needed to
 * create one every time the server hiccupped. "The server is down" is not "you have no
 * organization" — the shell renders the session's error state and offers a retry.
 */
export const hasOrganizationGuard: CanActivateFn = async () => {
  const session = inject(SessionService);
  const router = inject(Router);

  await session.load();

  if (session.status() === 'error') {
    return true;
  }
  if (session.hasOrganization()) {
    return true;
  }
  router.navigate(['/onboarding']);
  return false;
};
